/**
 * Delete all children within a THREE.js Object3D.
 *
 * @param {Object3D} parent Parent object to purge all children from.
 */
export function delete3dChildren(parent) {
    while (parent.children.length > 0) {
        parent.remove(parent.children[0]);
    }
}
